import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { apiCall, saveFile } from '../../components/special/apiCall';
import {useErrorContext} from 'components/messages/ErrorBox';
import InputDate from '../../components/input/InputDate';
import InputCheckBox from '../../components/input/InputCheckBox';
import { usePageLoadingContext } from '../../components/messages/PageLoading';
import { useLocale } from '../../components/special/LanguageProvider';



const BASE_URL = process.env.REACT_APP_ILWEB_API_URL;

export const ReturnSumTermReport = (props)  => {
    const [returnTerm, setReturnTerm] = useState({fromDate : new Date(), toDate : new Date(), splitCost : false});      

    const setCheckErrorItems = useErrorContext();
    const setIsPageLoading = usePageLoadingContext();
    const { t } = useLocale();


    const isResultOk = (obj) => {
        if ((obj != null) && (obj.error != undefined)){
            setCheckErrorItems([obj]);
            return null;
        }
        return obj;
    }

    const createReport = async () => {
        setIsPageLoading(true);
        console.log("Return sum term", returnTerm);
        const data = await apiCall(`${BASE_URL}/features/report/returnaccumulatedsumtermdata`,{ method: 'post', data: returnTerm});
        if (isResultOk(data)){
            saveFile(data.fileData, data.fileName, data.contentType);
        }
        setIsPageLoading(false);
    }

    useEffect(() => {
        setReturnTerm({...returnTerm, splitCost : false});
      }, []);

  return (
    <div>            
      <h1 className="text-red text-32">{t("Sundurliðun uppgjöra tímabil")}</h1>           
      <div>
        <div className="grid box" id="skref1">
            <div className="col s1of1">
                <div className="grid">
                    <div className="col s1of2">
                        <h3>{t("Dagsetning")}</h3>
                    </div>
                    <div className="col s1of2 text-right">
                        <p>{t("Skref") + " 1 " + t("af") + " 1 "}</p>
                    </div>
                </div>
            </div>
            <div className="col s1of1">
                <div className="grid">
                    <div className="form col s1of2">
                        <p>{t("Taka út sundurliðaða uppgjörsskýrslu fyrir skilgreint tímabil.")}</p>                        

                        <div className="col s1of1">
                            <div className="grid">
                                <div className="form col s1of2">
                                    Frá:
                                    <InputDate value={returnTerm.fromDate}  onChange={(value) => setReturnTerm({...returnTerm, fromDate : value})} />
                                </div>
                                <div className="form col s1of2">
                                    Til:
                                    <InputDate value={returnTerm.toDate}  onChange={(value) => setReturnTerm({...returnTerm, toDate : value})} />
                                </div>
                                <InputCheckBox name="splitCostCB" value={returnTerm.splitCost} label={"Fá sundurliðun á kostnaði sem ber VSK"} onChange={(value) => setReturnTerm({...returnTerm, splitCost : value})}  />
                            </div>
                            
                        </div>

                    </div>            
                    <div className="col s1of2 text-right">
                        
                    </div>
                </div>
            </div>
            <div className="col s1of1 text-right">
                <button className="button blue" onClick={createReport}>{t("Útbúa skýrslu í excel")}</button>                        
            </div>
        </div>    
        </div>
    </div>
  );
};
